/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log(
    "Expanse theme (" +
      theme.settings.themeVersion +
      ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
  );
}

(function () {
  "use strict";

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme &&
          window.theme.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    document.dispatchEvent(new CustomEvent("page:loaded"));

    if (window.location.href.includes('/blogs/')) {
      document.querySelectorAll('.shopify-section').forEach(section => {
          if (section.querySelector('div[data-section-type="background-image"] svg.placeholder-svg')) {
              section.remove();
              console.log('Removed section with background-image and svg:', section);
          }
          
          if (section.querySelector('.grid__item svg.placeholder-svg')) {
              section.remove();
              console.log('Removed section with grid__item and svg:', section);
          }
      });
    }

    // Check for videos 

    const productInfo = document.querySelectorAll(".product-block--tab, .product-info-tab-panel");

    productInfo.forEach(container => {
      const paragraphs = container.querySelectorAll("p");

      paragraphs.forEach(p => {
        const text = p.textContent.trim();

        if (text.includes("youtube.com/watch")) {
          const urlMatch = text.match(/https:\/\/www\.youtube\.com\/watch\?v=[^\s&]+/);

          if (urlMatch) {
            const url = urlMatch[0];

            const button = document.createElement("a");
            button.className = "product-instructions__instruction-link";
            button.href = url;
            button.target = "_blank";
            button.innerHTML = `
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-play-circle-fill" viewBox="0 0 16 16">
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814z"></path>
              </svg>
              <strong>Product video</strong>
            `;

            p.replaceWith(button);
          }
        }
      });
    });


    if (
      window.location.pathname.includes("/pages/zakelijk") ||
      window.location.pathname.includes("/pages/business") ||
      window.location.pathname.includes("/pages/unternehmen")
    ) {
          const observer = new MutationObserver((mutationsList, observer) => {
          const zakelijkFormEmbed = document.getElementById("app-embed-container-260518");
    
          if (zakelijkFormEmbed) {
              console.log('zakelijkFormEmbed found', zakelijkFormEmbed);
    
              zakelijkFormEmbed.classList.add("show-zakelijk");
              zakelijkFormEmbed.classList.remove("hide-zakelijk");
    
              document.querySelector('form-embed custom#formtype').value = 'Brainstorm popup';
    
              observer.disconnect(); // Stop observing once the element is found
          }
      });
    
      // Start observing changes in the document body
      observer.observe(document.body, { childList: true, subtree: true });
    }

    // Begin 
    let flickityInstance = null;

    function updateSliderHeight() {
      const popup = document.querySelector(".blog-popup");
      if (!popup) return;
    
      const popupHeight = popup.offsetHeight;
      const viewport = document.querySelector(".blog-popup .blog-popup-slider .flickity-viewport");
      const imageSlides = document.querySelectorAll(".blog-popup .blog-popup-slider .blog-popup-image-slide");
    
      if (viewport) {
        viewport.style.height = popupHeight + "px";
      }
    
      imageSlides.forEach(slide => {
        slide.style.height = popupHeight + "px";
      });
    }
    
    document.addEventListener("DOMContentLoaded", function () {
      const popup = document.querySelector(".blog-popup");
      if (popup) {
        const closeBtn = popup.querySelector(".close-btn");
        if (closeBtn) {
          closeBtn.addEventListener("click", function () {
            popup.classList.remove("open");
            const articleContent = popup.querySelector(".blog-article-content");
            if (articleContent) articleContent.remove();
    
            if (flickityInstance) {
              flickityInstance.destroy();
              flickityInstance = null;
            }
          });
        }
      }
    
      document.querySelectorAll(".blog-slider .article-image-slide").forEach(item => {
        item.addEventListener("click", function () {
          const blogPopup = document.querySelector(".blog-popup");
          if (!blogPopup) return;
      
          const blogPopupInner = document.querySelector(".blog-popup-inner");
          if (!blogPopupInner) return;
      
          const dataTitle = item.closest('.blog-slide')?.getAttribute('data-title') || "";
          const dataSummary = item.closest('.blog-slide')?.getAttribute('data-summary') || "";
          const dataUrl = item.closest('.blog-slide')?.getAttribute('data-url') || "#";
          const dataTags = item.closest('.blog-slide')?.getAttribute('data-tags') || "";
      
          // Maak de content van de blog
          const articleContent = document.createElement("div");
          articleContent.classList.add("blog-article-content");
      
          const title = document.createElement("h3");
          title.classList.add("title");
          title.textContent = dataTitle;
          articleContent.appendChild(title);
      
          const summary = document.createElement("p");
          summary.classList.add("summary");
          summary.textContent = dataSummary;
          articleContent.appendChild(summary);
      
          // Maak de Read More button
          const readMoreBtn = document.createElement("a");
          readMoreBtn.classList.add("readmore-btn", "btn");
          readMoreBtn.href = dataUrl;
          readMoreBtn.textContent = "Lees meer";
          articleContent.appendChild(readMoreBtn);
      
          // Voeg de tags toe als een lijst
          const bottomWrap = document.createElement("div");
          bottomWrap.classList.add("bottom-wrap");
      
          const tagsContainer = document.createElement("div");
          tagsContainer.classList.add("tags");
      
          // Splits de tags en voeg ze toe aan de container
          if (dataTags) {
            const tags = dataTags.split(", ");
            tags.forEach(tag => {
              const tagElement = document.createElement("span");
              tagElement.classList.add("tag");
              tagElement.textContent = tag;
              tagsContainer.appendChild(tagElement);
            });
          }
      
          bottomWrap.appendChild(readMoreBtn);
          bottomWrap.appendChild(tagsContainer);
          articleContent.appendChild(bottomWrap);
      
          blogPopupInner.appendChild(articleContent);
      
          // Haal de afbeeldingen en voeg ze toe aan de slider
          const slideImages = item.closest('.blog-slide')?.querySelectorAll('.article-image-slide');
          const popupSlider = document.querySelector(".blog-popup .blog-popup-slider");
      
          if (!popupSlider) return;
          popupSlider.innerHTML = "";
      
          slideImages?.forEach(slide => {
            const newSlide = document.createElement("div");
            newSlide.classList.add("blog-popup-image-slide");
      
            const img = document.createElement("img");
            const imageUrl = slide.style.backgroundImage.replace(/^url\(["']?/, '').replace(/["']?\)$/, '');
            
            let updatedImageUrl = imageUrl.includes('?') ? `${imageUrl}&width=1400` : `${imageUrl}?width=1400`;
            img.src = updatedImageUrl;
      
            newSlide.appendChild(img);
            popupSlider.appendChild(newSlide);
          });
      
          blogPopup.classList.add("open");
      
          // Initialiseer Flickity slider
          if (flickityInstance) {
            flickityInstance.destroy();
          }
      
          flickityInstance = new Flickity(popupSlider, {
            cellAlign: 'left',
            contain: true,
            autoPlay: false,
            wrapAround: true,
            groupCells: 1,
            prevNextButtons: true,
            pageDots: false
          });
      
          updateSliderHeight();
        });
      });

      function updatePriceDisplay() {
        document.querySelectorAll('.cart__item-price').forEach(function (priceContainer) {
            var priceElement = priceContainer.querySelector('.price-value .glc-money');
            var loader = priceContainer.querySelector('.loader');

            if (priceElement && loader) {
                var priceText = priceElement.textContent.replace(/[^\d,]/g, '').replace(',', '.'); // Extract numeric value
                var price = parseFloat(priceText);

                if (price < 1) {
                    priceElement.classList.add('hidden');
                    loader.classList.remove('hidden'); // Show spinner
                } else {
                    priceElement.classList.remove('hidden');
                    loader.classList.add('hidden'); // Hide spinner
                }
            }
        });
    }

    // Initial check
    updatePriceDisplay();

    // Observe changes dynamically
    var observer = new MutationObserver(updatePriceDisplay);
    document.querySelectorAll('.cart__item-price').forEach(function (priceContainer) {
        observer.observe(priceContainer, { childList: true, subtree: true });
    });
    
      document.addEventListener("click", function (event) {
        const popup = document.querySelector(".blog-popup");
        if (popup && popup.classList.contains("open") && !popup.contains(event.target) && !event.target.closest('.blog-slider .article-image-slide')) {
          popup.classList.remove("open");
          const articleContent = popup.querySelector(".blog-article-content");
          if (articleContent) articleContent.remove();
    
          if (flickityInstance) {
            flickityInstance.destroy();
            flickityInstance = null;
          }
        }
      });
    
      window.addEventListener("resize", function () {
        if (document.querySelector(".blog-popup")?.classList.contains("open")) {
          updateSliderHeight();
        }
      });


    });

  // End 

  });
})();

